import * as React from "react";
import { useSelector } from "../../../store/";
import { Container, CssBaseline, Box, Divider, Typography } from "@mui/material";
import Logo from "./../../ui-components/LogoText";

export default function MainLayout() {
	const client = useSelector((state) => state.client || {});

	return (
		<React.Fragment>
			<CssBaseline />
			<Container
				maxWidth="sm"
				sx={{
					bgcolor: "#06b6ad",
					height: "100%",
					display: "flex",
					flexDirection: "column",
					p: { xs: 0, sm: "2px" },
					pl: { xs: 0, sm: "6px" },
					position: "relative",
				}}
			>
				<Box
					sx={{
						minHeight: "125px",
						height: {
							xs: "calc(100% - 70vh)",
							sm: "calc(100% - 70vh)",
						},
                        py: 10,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					{client?.details?.logo?.absolute ? (
						<img
							alt="logo"
							src={client.details.logo.absolute}
							style={{ maxWidth: "22rem", maxHeight: "11rem" }}
						/>
					) : (
						<Logo width="80px" />
					)}
				</Box>
                <Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
				<Typography
					variant="h3_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
					}}
				>
					OOPS...
				</Typography>
				<Typography
					variant="h6"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
					}}
				>
                    Something went wrong.<br />Please try refreshing your screen, or contact your training company if issues continue.
				</Typography>
				<Divider sx={{ my: 3 }} />
				{/* <Typography
					variant="tlrg_footer"
					sx={{
						textAlign: "center",
						display: "flex",
						justifyContent: "center",
						mb: 5,
					}}
				>
					The Learning Resources Group
				</Typography> */}
			</Box>
			</Container>
		</React.Fragment>
	);
}
